import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LanguageService } from '../../core';


/**
 * Base component to share common features in every component.
 */
@Component({
	selector: 'app-base',
	template: '',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class BaseComponent {

	private readonly langSrv = inject(LanguageService);

	labels = computed(() => this.langSrv.labels());

}
